module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/aq564-3b0386c8ede99b0a2fa540b670bfd76c.jpg";